import { gql } from '@apollo/client'

export const GET_COMPANY_CHAINS = gql`
  query GetCompanyChains {
    companyChains {
      id
      name
    }
  }
`
